import {
  Favorite,
  AddShoppingCart,
  FavoriteBorder,
  CompareArrows,
} from "@mui/icons-material";
import {
  Card,
  CardHeader,
  Avatar,
  CardActions,
  Button,
  Box,
  Tooltip,
  Typography,
  ButtonGroup,
} from "@mui/material";
import { PUIContentCarousel } from "modules/UI/components/ContentCarousel.component";
import PUIRatioBox from "modules/UI/components/RatioBox.component";
import React from "react";
import StaticResources from "service/dummyData/resources";
import { PslMaterial } from "../domains/pslMaterial.domain";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import PromoItemsService from "../services/promoItems.service";
import { toTitleCase } from "utils/utils";
import { useActiveUser } from "modules/User/activeUser";
import { useCompare } from "../containers/compare.container";
import { useFeatures } from "modules/FeatureManagement/service/featureManagement.hooks";

export const PromoItemCard = ({
  promoItem,
  onRefetch,
  onPreview,
}: {
  promoItem;
  onRefetch?: (promoItem: any) => void;
  onPreview?: () => void;
}) => {
  const { selectedMaterials, clearAll, addMaterial } = useCompare();
  const queryClient = useQueryClient();
  const activeUser = useActiveUser();
  const features = useFeatures();
  const { mutateAsync: toggleFavorite, status } = useMutation({
    mutationKey: ["toggleFavorite"],
    mutationFn: async () => {
      await PromoItemsService.toggleFavoriteMaterial({
        pslId: promoItem.pslId,
      });
    },
    onSuccess: () => {
      if (onRefetch) onRefetch(promoItem);
    },
  });
  const pricesRanges = promoItem?.priceRanges
    ?.sort((a, b) => a.quantity - b.quantity)
    ?.reverse()
    ?.find((range) => range.quantity <= promoItem?.minimumOrderQuantity);

  const promoCategory = StaticResources.promoCategories.find(
    (c) => c.id?.toString() === promoItem.promoCategoryId?.toString()
  );
  console.log("promoItem1:", promoItem);
console.log("mediaFiles1:", promoItem.mediaFiles);
console.log("parentMediaFiles1:", promoItem.parentMediaFiles);
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 420,
        minHeight: "100%",
        display: "flex",
        flexFlow: "row wrap",
        flexGrow: 1,
        cursor: "pointer",
        "&:hover": {
          boxShadow: 10,
        },
      }}
      elevation={0}
      onClick={onPreview}
    >
      {/* <SwipeableTextMobileStepper row={promoItem} /> */}
      <Box sx={{ width: "100%" }}>
        {(() => {
          // Use child media files if available, otherwise fallback to parent media files
          const childPhotoFiles = promoItem.mediaFiles?.filter((file) => file?.isQuality === false) || [];
          const parentPhotoFiles = promoItem.parentMediaFiles?.filter((file) => file?.isQuality === false) || [];
//           const childPhotoFiles =
//   promoItem.mediaFiles?.filter(
//     (file) =>
//       file?.isQuality === false &&
//       file?.mimeType?.startsWith("image/")
//   ) || [];

// const parentPhotoFiles =
//   promoItem.parentMediaFiles?.filter(
//     (file) =>
//       file?.isQuality === false &&
//       file?.mimeType?.startsWith("image/")
//   ) || [];
          const photoFiles = childPhotoFiles.length > 0 ? childPhotoFiles : parentPhotoFiles;
          
          return photoFiles.length > 0 ? (
 <PUIContentCarousel
  data={photoFiles.map((file) => ({
    type:
      file?.mimeType === "application/pdf"
        ? "pdf"
        : "image",
    thumbnail: file.url,
    src: file.url,
    fileName:
      file.originalFileName ||
      file.fileName ||
      file.name,
  }))}
  onPreview={onPreview}
/>
) : (
          <PUIRatioBox xRatio={16} yRatio={9}>
            <Avatar
              variant="square"
              sx={{
                width: "100%",
                height: "100%",
                // background: "linear-gradient(112.5deg, rgb(214, 214, 214) 0%, rgb(214, 214, 214) 10%,rgb(195, 195, 195) 10%, rgb(195, 195, 195) 53%,rgb(176, 176, 176) 53%, rgb(176, 176, 176) 55%,rgb(157, 157, 157) 55%, rgb(157, 157, 157) 60%,rgb(137, 137, 137) 60%, rgb(137, 137, 137) 88%,rgb(118, 118, 118) 88%, rgb(118, 118, 118) 91%,rgb(99, 99, 99) 91%, rgb(99, 99, 99) 100%),linear-gradient(157.5deg, rgb(214, 214, 214) 0%, rgb(214, 214, 214) 10%,rgb(195, 195, 195) 10%, rgb(195, 195, 195) 53%,rgb(176, 176, 176) 53%, rgb(176, 176, 176) 55%,rgb(157, 157, 157) 55%, rgb(157, 157, 157) 60%,rgb(137, 137, 137) 60%, rgb(137, 137, 137) 88%,rgb(118, 118, 118) 88%, rgb(118, 118, 118) 91%,rgb(99, 99, 99) 91%, rgb(99, 99, 99) 100%),linear-gradient(135deg, rgb(214, 214, 214) 0%, rgb(214, 214, 214) 10%,rgb(195, 195, 195) 10%, rgb(195, 195, 195) 53%,rgb(176, 176, 176) 53%, rgb(176, 176, 176) 55%,rgb(157, 157, 157) 55%, rgb(157, 157, 157) 60%,rgb(137, 137, 137) 60%, rgb(137, 137, 137) 88%,rgb(118, 118, 118) 88%, rgb(118, 118, 118) 91%,rgb(99, 99, 99) 91%, rgb(99, 99, 99) 100%),linear-gradient(90deg, rgb(195, 195, 195),rgb(228, 228, 228)); background-blend-mode:overlay,overlay,overlay,multiply",
                backgroundColor: promoCategory?.color || "#ccc",
                backgroundImage:
                  "linear-gradient(0deg, rgba(0,0,0,1), rgba(255,255,255,.1))",
                backgroundBlendMode: "overlay",
                "& svg": {
                  opacity: 0.2,
                  width: "50%",
                  height: "50%",
                },
              }}
            >
              {promoCategory ? <promoCategory.icon /> : <></>}
            </Avatar>
          </PUIRatioBox>
          );
        })()}
      </Box>

      <CardHeader
        // avatar={<Avatar sx={{ bgcolor: orange[500] }}>M</Avatar>}
        sx={{
          maxWidth: "100%",
          marginBottom: "auto",
          ".MuiCardHeader-title": {
            fontSize: "1rem",
            fontWeight: "bold",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          "& *": {
            maxWidth: "100%",
          },
        }}
        title={
          <Tooltip title={`${promoItem.shortDescription}`}>
            {toTitleCase(`${promoItem.shortDescription}`)}
          </Tooltip>
        }
       subheader={
  <>
    <Tooltip title={promoItem?.detailedDescription || ""}>
      <Typography variant="body2" noWrap>
        {promoItem?.materialNumber} | {promoItem?.detailedDescription}
      </Typography>
    </Tooltip>

    <Typography variant="body2">
      {promoItem?.pslIdWithPrefix}
      {promoItem?.markets?.length
        ? ` | ${promoItem.markets[0].name}`
        : ""}
    </Typography>

    {!!promoItem &&
      !!pricesRanges?.price &&
      !!promoItem?.currencyCode &&
      !!pricesRanges?.pricePer &&
      !!promoItem?.unitOfMeasure && (
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: "bold",
          }}
        >
          {pricesRanges?.price} {promoItem?.currencyCode} per{" "}
          {pricesRanges?.pricePer} {promoItem?.unitOfMeasure}
        </Typography>
      )}
  </>
}
//         subheader={
//   <>
//     <Typography variant="body2">
//       {promoItem?.materialNumber} | {promoItem?.shortDescription}
//     </Typography>

//     <Typography variant="body2">
//       {promoItem?.pslIdWithPrefix}
//       {promoItem?.marketLocation
//         ? ` | ${promoItem.marketLocation}`
//         : ""}
//     </Typography>

//     {!!promoItem &&
//       !!pricesRanges?.price &&
//       !!promoItem?.currencyCode &&
//       !!pricesRanges?.pricePer &&
//       !!promoItem?.unitOfMeasure && (
//         <Typography
//           sx={{
//             fontSize: "1rem",
//             fontWeight: "bold",
//           }}
//         >
//           {pricesRanges?.price} {promoItem?.currencyCode} per{" "}
//           {pricesRanges?.pricePer} {promoItem?.unitOfMeasure}
//         </Typography>
//       )}
//   </>
// }
      />
      {/* <CardMedia
        component="img"
        height="194"
        image="/static/images/cards/paella.jpg"
        alt="Paella dish"ß
      /> */}
      <CardActions sx={{ justifyContent: "space-between", width: "100%" }}>
        {/* <span>
          <Star sx={{ color: orange[500] }} /> 4.5
        </span> */}
        {/* <ButtonGroup> */}

        <ButtonGroup>
          {/* <Button
            aria-label="add to favorites"
            variant="text"
            onClick={(e) => {
              e.stopPropagation();
              toggleFavorite();
            }}
            disabled={status === "pending"}
          >
            {promoItem.isFavorite ? <Favorite /> : <FavoriteBorder />}
          </Button> */}
          {/* {features["enableV2"] &&
            PslMaterial.build(promoItem).canBeRequested() &&
            !activeUser.isViewOnly() &&
            activeUser.isMember() && (
              <Button
                aria-label="compare"
                variant="text"
                onClick={(e) => {
                  e.stopPropagation();
                  addMaterial(promoItem);
                }}
                sx={{ mr: "auto" }}
                disabled={selectedMaterials.indexOf(promoItem) !== -1}
              >
                <CompareArrows />
              </Button>
            )} */}
        </ButtonGroup>
        {PslMaterial.build(promoItem).canBeRequested() &&
          !activeUser.isViewOnly() &&
          activeUser.isMember() && (
            <ButtonGroup>
              <Button
                variant="contained"
                size="medium"
                color="primary"
                startIcon={<AddShoppingCart />}
              >
                Add
              </Button>
            </ButtonGroup>
          )}
      </CardActions>
    </Card>
  );
};

export default PromoItemCard;
